import docSignStyles from "../../../styles/documentSigning/DocSign.filters.module.css"
const LayoutButton = ({
  iconName,
  toolTip,
  value,
  setLayoutOption,
  layoutOption,
  disabled,
}) => {
  return (
    <button
      type="button"
      className={`btn t-tip ${docSignStyles.filterHeaderButton} ${
        layoutOption === value ? docSignStyles.layoutButtonSelected : ""
      }`}
      data-pr-tooltip={toolTip}
      data-pr-position="bottom"
      onClick={(e) => {
        e.stopPropagation()
        setLayoutOption(value)
      }}
      disabled={disabled}
    >
      <span className={`material-icons`}>{iconName}</span>
    </button>
  )
}
export default LayoutButton
